module.exports = __webpack_public_path__ + "/dist/subscribe_bg.png";